import { Color } from "../types";

export const cerata = (color: Color) => ({
  backgroundColor: `${color}30`,
  backgroundImage: `linear-gradient(90deg, ${color}80 50%, transparent 50%),
linear-gradient(${color}aa 50%, transparent 50%)`,
  backgroundSize: "25px 25px",
  backgroundPosition: "3px 5px",
});
